import React, { useState } from 'react';
import { Form, Button, ListGroup, InputGroup } from 'react-bootstrap';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './Project.css';

function Projects({ user, setUser }) {
  const [project, setProject] = useState('');
  const [deadline, setDeadline] = useState(new Date());
  const [showCalendar, setShowCalendar] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editText, setEditText] = useState('');

  const saveUserData = (updatedUser) => {
    setUser(updatedUser);
    localStorage.setItem('currentUser', JSON.stringify(updatedUser));
    localStorage.setItem(
      'users',
      JSON.stringify(
        JSON.parse(localStorage.getItem('users') || '[]').map((u) =>
          u.email === user.email ? updatedUser : u
        )
      )
    );
  };

  const addProject = () => {
    if (!project.trim()) return;
    const newProject = {
      id: Date.now(),
      text: project.trim(),
      deadline: deadline.toISOString(),
    };
    saveUserData({ ...user, projects: [...user.projects, newProject] });
    setProject('');
  };

  const deleteProject = (id) => {
    saveUserData({
      ...user,
      projects: user.projects.filter((p) => p.id !== id),
    });
  };

  const startEdit = (id, currentText) => {
    setEditingId(id);
    setEditText(currentText);
  };

  const saveEdit = (id) => {
    saveUserData({
      ...user,
      projects: user.projects.map((p) =>
        p.id === id ? { ...p, text: editText } : p
      ),
    });
    setEditingId(null);
    setEditText('');
  };

  return (
    <div className="projects-container">
      <h3 className="projects-title">📂 Projects</h3>

      <InputGroup className="mb-3">
        <Form.Control
          type="text"
          value={project}
          onChange={(e) => setProject(e.target.value)}
          placeholder="Add a project"
        />
        <Button variant="outline-secondary" onClick={() => setShowCalendar(!showCalendar)}>
          📅
        </Button>
        <Button variant="primary" onClick={addProject}>
          ➕ Add
        </Button>
      </InputGroup>

      {showCalendar && (
        <div className="calendar-wrapper">
          <Calendar onChange={setDeadline} value={deadline} />
        </div>
      )}

      <ListGroup className="mt-3">
        {user.projects.map((p) => (
          <ListGroup.Item key={p.id} className="project-item">
            {editingId === p.id ? (
              <>
                <Form.Control
                  type="text"
                  value={editText}
                  onChange={(e) => setEditText(e.target.value)}
                  className="edit-input"
                />
                <Button size="sm" variant="success" onClick={() => saveEdit(p.id)}>
                  💾
                </Button>
                <Button size="sm" variant="secondary" onClick={() => setEditingId(null)}>
                  ❌
                </Button>
              </>
            ) : (
              <>
                <span>
                  {p.text} —{' '}
                  {new Date(p.deadline).toLocaleDateString(undefined, {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                  })}
                </span>
                <div className="action-buttons">
                  <Button size="sm" variant="link" onClick={() => startEdit(p.id, p.text)}>
                    ✏️
                  </Button>
                  <Button size="sm" variant="link" onClick={() => deleteProject(p.id)}>
                    🗑️
                  </Button>
                </div>
              </>
            )}
          </ListGroup.Item>
        ))}
      </ListGroup>
    </div>
  );
}

export default Projects;
